import { Checkbox, FormControlLabel } from "@mui/material";
import { styled } from "@mui/material/styles";
import TableMap from "Components/OrderComponents/TableSection/TableMap";
import TableSectionDrawer from "Components/OrderComponents/TableSection/TableSectionDrawer";
import { useFormikContext } from "formik";
import { useOrderAttributeProvider } from "Pages/Order/Order/context/order";
import React, { useState } from "react";
import { useProductManage } from "../hooks/useProductMange";
import AddonContent from "./AddonContainerNewContext";
import Custom from "./Custom";
import ProductContent from "./ProductContentNewContext";
import ProductPriceEdit from "./ProductPriceEdit";
import { storeIdsForStoreProductVariation } from "../utility/util";
import EditRecipeOrder from "./EditRecipeOrder";
const ProductSection = (props) => {
  const { active, orderDetail } = useOrderAttributeProvider();
  const formik = useFormikContext();

  const [open, setOpen] = useState(false);
  const [customOpen, setCustomOpen] = useState(false);
  const [editOpen, setEditOpen] = useState(false);
  const [editRecipeOpen, setEditRecipeOpen] = useState(false);
  const [editData, setEditData] = useState({
    index: 0,
    data: {}
  });
  const [currentDrawer, setCurrentDrawer] = useState(null);

  const {
    deleteProduct,
    increaseProductQty,
    decreaseProductQty,
    decreaseAddonQty,
    increaseAddonQty,
    deleteAddon,
    editProduct,
    editAddon,
    deleteAllProduct,
    validateLocalNonLocalProducts
  } = useProductManage();

  let currentRecipient = formik.values.recipients[active];
  const orderRecipients = orderDetail?.order_recipients?.find((recip)=>recip?.id === currentRecipient?.sql_id)
  
  // Handle saving recipe data
  const handleSaveRecipe = (latestProductRecipeData=[]) => {
    let recipients = [...formik.values.recipients];
    const productIndex = editData.index;
    if(recipients[active]?.products && recipients[active].products.length > 0 ){
      recipients[active].products[productIndex] = {
        ...recipients[active].products[productIndex],
        order_product_recipes: latestProductRecipeData,
      };
      // Update formik values
      formik.setValues((v) => {
        return {
          ...v,
          recipients
        };
      });
    }
  };

  // ✅ Converted from withStyles to styled (MUI v5)
  const GreenCheckbox = styled(Checkbox)(({ theme }) => ({
    color: "#CB998D",
    "&.Mui-checked": {
      color: "#CB998D"
    }
  }));

  return (
    <div className="row col-12">
      <div className="col-12">
        &nbsp;
        {/* <FormControlLabel
          control={
            <GreenCheckbox
              disabled={active > 0}
              checked={formik.values.custom_order === 1}
              onChange={() => {
                let newValue = 1;
                if (formik.values.custom_order === 1) {
                  newValue = 0;
                }
                // deleteAllProduct();
                // let recipients = [...formik.values.recipients];
                // recipients = recipients.map((r) => {
                //   r.products = [];
                //   return r;
                // });

                formik.setValues((v) => {
                  return {
                    ...v,
                    custom_order: newValue,
                    // recipients: recipients,
                  };
                });
              }}
            />
          }
          label="Custom Price Order"
        /> */}
      </div>
      <div className="col-md-6">
        <TableMap
          module={props.module}
          onDecrease={decreaseProductQty}
          onIncrease={increaseProductQty}
          onDelete={deleteProduct}
          onEditRecipe={(i, d, title) => {
            setEditRecipeOpen(true)
            setEditData({
              index: i,
              data: d,
              title: title
            })
          }}
          onEdit={async (i, d, title) => {
            await setEditData({
              index: i,
              data: d,
              title: title
            });
            setEditOpen(true)
          }}
          OnAddClick={(e) => {
            // if (formik.values.custom_order === 1) {
            //   setCustomOpen(true);
            // } else {
            formik.setValues((v) => {
              return {
                ...v,
                custom_order: 0,
              };
            });
            setOpen(true);
            setCurrentDrawer("product");
            // }
          }}
          OnAddClickCustom={() => {
            formik.setValues((v) => {
              return {
                ...v,
                custom_order: 1,
              };
            });
            setCustomOpen(true);
          }}
          title="Products"
          list={currentRecipient.products ?? []}
          orderProducts={orderRecipients?.order_products}
        />
      </div>
      <div className="col-md-6">
        <TableMap
          module={props.module}
          onDecrease={decreaseAddonQty}
          onIncrease={increaseAddonQty}
          onDelete={deleteAddon}
          onEdit={async (i, d, title) => {
            await setEditData({
              index: i,
              data: d,
              title: title
            });
            setEditOpen(true)
          }}
          title="Addons"
          list={currentRecipient.addons ?? []}
          orderProducts={orderRecipients?.order_products}
          OnAddClick={() => {
            setOpen(true);
            setCurrentDrawer("addon");
          }}
        />
      </div>
      {customOpen && (
        <Custom
          addProduct={(product) => {
            let recipients = [...formik.values.recipients];
            product.total_price = +product.total_price;
            product.total_price = +product.selectedVariant.price;
            product.custom_product_flag = 1;
            //unique key for each product recipent wise
            product.product_key = product.product_key || `prod_${product.id}_${product.selectedVariant.id}_${new Date().getTime()}`;
            product.order_product_recipes = []; 
            recipients[active].products.push(product);
            const storeId = storeIdsForStoreProductVariation([product]);
            formik.setValues((v) => {
              return {
                ...v,
                recipients,
                cart_products:{
                  // is_non_local_only: formik.values.delivery_information?.is_local == 1 ? 1 : 0,
                  ...v.cart_products,
                  product_variation_storeIds : [...v?.cart_products?.product_variation_storeIds, ...storeId]
                }
              };
            });
            setCustomOpen(false);
          }}
          open={customOpen}
          onClose={() => setCustomOpen(false)}
          values={formik.values}
        />
      )}
      {editOpen && (
        <ProductPriceEdit
          editProduct={editProduct}
          editAddon={editAddon}
          editData={editData}
          open={editOpen}
          onClose={() => setEditOpen(false)}
        />
      )}
      {editRecipeOpen && (
        <EditRecipeOrder
          module={props.module}
          open={editRecipeOpen}
          orderDetail={orderDetail}
          orderStatus={orderDetail?.order_status || ""}
          editData={editData}
          onClose={() => setEditRecipeOpen(false)}
          onSaveRecipe={handleSaveRecipe}
        />
      )}
      {open && currentDrawer && (
        <TableSectionDrawer
          open={open}
          onClose={() => {
            setCurrentDrawer(null);
            setOpen(false);
          }}
        >
          {currentDrawer === "product" && (
            <ProductContent
              onAdd={(products) => {
                let recipients = [...formik.values.recipients];
                recipients[active].products.push(...products);
                const storeIds = storeIdsForStoreProductVariation(products);
                const isNonLocal = validateLocalNonLocalProducts(products);
                formik.setValues((v) => {
                  return {
                    ...v,
                    recipients,
                    cart_products:{
                      is_non_local_only: isNonLocal,
                      product_variation_storeIds: [...v?.cart_products?.product_variation_storeIds, ...storeIds]
                    }
                  };
                });
                setOpen(false);
                setCurrentDrawer(null);
              }}
              onClose={() => {
                setOpen(false);
                setCurrentDrawer(null);
              }}
            />
          )}
          {currentDrawer === "addon" && (
            <AddonContent
              onAdd={(addons) => {
                let recipients = [...formik.values.recipients];
                recipients[active].addons.push(...addons);
                const storeIds = storeIdsForStoreProductVariation(addons);
                const isNonLocal = validateLocalNonLocalProducts(addons);
                formik.setValues((v) => {
                  return {
                    ...v,
                    recipients,
                    cart_products:{
                      is_non_local_only: isNonLocal,
                      product_variation_storeIds: [...v?.cart_products?.product_variation_storeIds, ...storeIds]
                    }
                  };
                });
                setOpen(false);
                setCurrentDrawer(null);
              }}
              onClose={() => {
                setOpen(false);
                setCurrentDrawer(null);
              }}
            />
          )}
        </TableSectionDrawer>
      )}
    </div>
  );
};

export default ProductSection;
